// This file is generated.
export var version = '1.41.0';
//# sourceMappingURL=version.js.map